import * as XLSX from 'xlsx';

type ParsedFile = {
	name: string;
	data: any[][];
};

export const readSpreadsheetFile = async (file: File): Promise<ParsedFile> => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();

		// Evento para processar o arquivo
		reader.onload = (e) => {
			try {
				const arrayBuffer = e.target?.result as ArrayBuffer;

				// Converte o conteúdo para um Workbook
				const workbook = XLSX.read(arrayBuffer, { type: 'array' });

				// Pega a primeira folha de dados
				const sheetName = workbook.SheetNames[0];
				const sheet = workbook.Sheets[sheetName];

				// Converte os dados da folha para JSON ou Array
				const data = XLSX.utils.sheet_to_json(sheet, {
					header: 1,
				}) as any[][];

				resolve({
					name: file.name,
					data,
				});
			} catch (error) {
				reject(error);
			}
		};

		// Ler o arquivo como ArrayBuffer
		reader.onerror = () => reject(new Error('Erro ao ler o arquivo.'));
		reader.readAsArrayBuffer(file);
	});
};
